export interface JwtClaims {
    user?: string;
    username?: string;
    domain?: string;
    [key: string]: unknown;
}

export function decodeJwt(token: string): JwtClaims | null {
    try {
        const parts = token.split(".");
        if (parts.length !== 3) {
            return null;
        }
        let base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
        while (base64.length % 4) {
            base64 += "=";
        }
        const json = decodeURIComponent(
            atob(base64)
                .split("")
                .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
                .join("")
        );
        const parsed = JSON.parse(json);
        if (typeof parsed !== "object" || parsed === null) {
            return null;
        }
        return parsed as JwtClaims;
    } catch {
        return null;
    }
}
